export const CONTRACT_ADDRESS = '0x3607b75b5b7dc9cd448c1e23222913cb2f4b8c6b';

export const LINKS = {
  buy: 'https://argus.world/token/0x3607B75B5b7DC9CD448C1e23222913cb2f4b8c6B',
  x: 'https://x.com/Arc_Toons',
  chart: 'https://dexscreener.com/arc/0xb53f3908181d38f9c78d8569c702529cb4b20767a61c34ee25eadf1ea91395d3'
};

export const shortCa = (ca = CONTRACT_ADDRESS) => `${ca.slice(0, 6)}…${ca.slice(-4)}`;

export async function copyCa() {
  try {
    await navigator.clipboard.writeText(CONTRACT_ADDRESS);
    return true;
  } catch (e) {
    return false;
  }
}

export const NAV_ITEMS = [
  { id: 'home', label: 'HOME', path: '/' },
  { id: 'universe', label: 'UNIVERSE', path: '/universe' },
  { id: 'toons', label: 'TOONS', path: '/toons' },
  { id: 'story', label: 'STORY', path: '/story' },
  { id: 'ecosystem', label: 'ECOSYSTEM', path: '/ecosystem' },
  { id: 'news', label: 'NEWS', path: '/news' }
];

export const TAGLINE_PRIMARY = 'THE CARTOON UNIVERSE OF ARC';
export const TAGLINE_SECONDARY = 'ONE CHAIN • MANY TOONS • INFINITE STORIES';

export const TOONS = [
  {
    id: 'trader',
    index: '01',
    image: '/assets/karakter-1-opt.webp',
    imageFull: '/assets/karakter-1.png',
    role: 'THE TRADER',
    accent: '#7CFF4D',
    accentSoft: 'rgba(124,255,77,0.16)',
    tagline: 'Never misses a green candle.',
    personality: 'Cool. Sharp. Always three screens ahead.',
    lore: 'First seen down in the lower markets of Toon City, flipping holographic tickers before the sun rose over the Arc skyline. If a chart is moving anywhere in the Toonverse, the Trader already knows about it.',
    status: 'COMING SOON'
  },
  {
    id: 'strategist',
    index: '02',
    image: '/assets/karakter-2-opt.webp',
    imageFull: '/assets/karakter-2.png',
    role: 'THE STRATEGIST',
    accent: '#FF7A18',
    accentSoft: 'rgba(255,122,24,0.16)',
    tagline: 'Ten steps ahead of the neon rush.',
    personality: 'Sly. Fearless. Always three moves ahead.',
    lore: 'Nobody remembers when the Fox arrived — only that the streets got brighter that day. The Strategist moves through the neon alleys of Toon City, collecting every winning play in a coat full of glowing pockets.',
    status: 'COMING SOON'
  },
  {
    id: 'builder',
    index: '03',
    image: '/assets/karakter-3-opt.webp',
    imageFull: '/assets/karakter-3.png',
    role: 'THE BUILDER',
    accent: '#1677FF',
    accentSoft: 'rgba(22,119,255,0.18)',
    tagline: 'The first Toon. The point of origin.',
    personality: 'Confident. Relentless. Points at the future.',
    lore: 'Sits on the rooftops of Toon City pointing toward the horizon — always toward what comes next. Where others see a chain, the Builder sees a universe waiting to be drawn.',
    status: 'COMING SOON'
  },
  {
    id: 'agent',
    index: '04',
    image: '/assets/karakter-4-opt.webp',
    imageFull: '/assets/karakter-4.png',
    role: 'THE AGENT',
    accent: '#00C8FF',
    accentSoft: 'rgba(0,200,255,0.16)',
    tagline: 'Peace. Signals. Unknown origin.',
    personality: 'Curious. Calm. Processes everything.',
    lore: 'Nobody knows who built the Agent. It drifts through Toon City collecting signals, trading peace signs, and processing the Toonverse one frame at a time.',
    status: 'COMING SOON'
  },
  {
    id: 'whale',
    index: '05',
    image: '/assets/karakter-5-opt.webp',
    imageFull: '/assets/karakter-5.png',
    role: 'THE WHALE',
    accent: '#FFB52E',
    accentSoft: 'rgba(255,181,46,0.16)',
    tagline: 'King of the deep liquidity seas.',
    personality: 'Regal. Generous. Moves markets quietly.',
    lore: 'Crowned ruler of the deepest waters in the Toonverse. Gold chains, golden coins, golden moves. When the Whale swims, the whole city feels the tide.',
    status: 'COMING SOON'
  }
];

export const CITY_MENU = [
  { id: 'build', label: 'BUILD', desc: 'Where Toons ship new worlds into the skyline.' },
  { id: 'trade', label: 'TRADE', desc: 'Value moves across the Arc chain at light speed.' },
  { id: 'create', label: 'CREATE', desc: 'Stories, art and characters are born here.' },
  { id: 'play', label: 'PLAY', desc: 'The whole city is a playground.' },
  { id: 'explore', label: 'EXPLORE', desc: 'Every district hides a new story.' }
];

export const STORY = [
  {
    chapter: '01',
    title: 'THE ARRIVAL',
    text: 'In a world where digital culture moves at the speed of the internet, a new universe appeared on Arc.',
    visual: 'city'
  },
  {
    chapter: '02',
    title: 'TOON CITY',
    text: 'A city of light rose above the clouds — filled with builders, traders, agents, explorers and characters.',
    visual: 'banner'
  },
  {
    chapter: '03',
    title: 'THE TOONS',
    text: 'They are the Toons. Each one brings a different personality. Each one has a different story.',
    visual: 'group'
  },
  {
    chapter: '04',
    title: 'THE COMMUNITY',
    text: 'Together they form ARC TOONS. The people are the universe — and the universe keeps growing.',
    visual: 'trio'
  },
  {
    chapter: '05',
    title: 'THE TOONVERSE',
    text: 'One chain. Many Toons. Infinite stories. The Toonverse is just getting started.',
    visual: 'logo'
  }
];

export const PILLARS = [
  {
    id: 'build',
    index: '01',
    title: 'BUILD',
    desc: 'For builders and creators.',
    accent: '#1677FF'
  },
  {
    id: 'trade',
    index: '02',
    title: 'TRADE',
    desc: 'Explore the Arc ecosystem.',
    accent: '#00C8FF'
  },
  {
    id: 'create',
    index: '03',
    title: 'CREATE',
    desc: 'Characters, stories and digital culture.',
    accent: '#FFB52E'
  },
  {
    id: 'community',
    index: '04',
    title: 'COMMUNITY',
    desc: 'The people who bring the universe to life.',
    accent: '#FF7A18'
  }
];
